<template>
  <div v-if="isUserDataLoaded" class="card">
    <!--Header-->
    <div class="card-header">
      <b-row no-gutters class="pb-2 pr-0">
        <b-col md="2" class="fl-flex-label fl-collapsed">
          <b-form-checkbox
              v-model="applyManifestFilter"
              title="Selecione esta opção para indicar uma Transferência Interna. Ao selecionar, você precisará informar a chave de manifesto."
          >
            <span class="cursor-pointer">Transferência interna [?]</span>
          </b-form-checkbox>
        </b-col>
      </b-row>
      <b-row no-gutters class="pb-1 pr-0 justify-content-start">
        <b-col lg="2" md="6" sm="12" class="fl-flex-label fl-collapsed mb-sm-1 pr-1">
          <multiselect
            v-model="triagem"
            :options="optionsGrupoTriagem"
            :open-direction="'bottom'"
            :disabled="area.input.trim() !== ''"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Grupo de Triagem"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
            :clear-on-select="false"
          />
        </b-col>

        <b-col lg="1" md="3" sm="12" :cols="pallet.visible ? 8 : 12" class="fl-flex-label fl-collapsed mb-sm-1 pr-1">
          <input type="text" class="form-control" v-model="area.input" autofocus @keyup.enter="onFetchScreeningGroup" ref="area"
            autocomplete="off" :disabled="!triagem" />
          <label class="fl-label" style="left: 13px; right: 12px" @click="$refs.area.focus()">Area</label>
          <b-form-feedback class="text-danger" v-text="errors.get('area_id')" v-if="errors.has('area_id')"></b-form-feedback>
        </b-col>

        <b-col lg="1" md="2" sm="12"  v-if="plate.visible" cols="4" class="fl-flex-label fl-collapsed mb-sm-1  pr-1">
          <input type="text" class="form-control" v-model="plate.input" @keyup.enter="$refs.mdfe.focus()"
                 ref="plate" :disabled="plate.disabled" autocomplete="off" />
          <label class="fl-label" style="left: 13px; right: 12px" @click="$refs.plate.focus()">Placa do veículo</label>
        </b-col>

        <b-col lg="1" md="2" sm="12"  v-if="pallet.visible" cols="4" class="fl-flex-label fl-collapsed mb-sm-1  pr-1">
          <input type="text" class="form-control" v-model="pallet.input" @keyup.enter="$refs.barcode.focus()"
            ref="pallet" :disabled="pallet.disabled" autocomplete="off" />
          <label class="fl-label" style="left: 13px; right: 12px" @click="$refs.pallet.focus()">Pallet</label>
          <b-form-feedback class="text-danger" v-text="errors.get('pallet_id')" v-if="errors.has('pallet_id')"></b-form-feedback>
        </b-col>

        <b-col lg="1" md="2" sm="12"  cols="6" class="fl-flex-label fl-collapsed mb-sm-1 pr-1" v-if="!applyManifestFilter">
          <b-input v-model="batch.input" :disabled="batch.disabled" @keyup.enter="onSetBatch()" ref="batch">
          </b-input>
          <label class="fl-label" style="left: 13px; right: 12px" @click="$refs.batch.focus()">Lote</label>
          <b-form-feedback class="text-danger" v-text="errors.get('lote')" v-if="errors.has('lote')"></b-form-feedback>
        </b-col>

        <b-col :lg="applyManifestFilter ? '4' : '3'" :md="applyManifestFilter ? '4' : '3'" sm="12"  cols="6" class="fl-flex-label fl-collapsed mb-sm-1  pr-1">
          <b-input v-model="mdfe.input" :disabled="mdfe.disabled" maxlength="44" ref="mdfe">
          </b-input>
          <label class="fl-label" style="left: 13px; right: 12px" @click="$refs.mdfe.focus()">MDFe</label>
          <b-form-feedback class="text-danger" v-text="errors.get('mdfe')" v-if="errors.has('mdfe')"></b-form-feedback>
        </b-col>

        <b-col lg="4" md="6" sm="12"  class="fl-flex-label fl-collapsed">
          <b-input v-model="barcode.input" id="barcode" maxlength="31" type="text" v-on:keyup.enter="onScan()"
            ref="barcode" :disabled="barcode.disabled" @contextmenu="!barcode.canWrite && $event.preventDefault()"
            @dragover="!barcode.canWrite && $event.preventDefault()"
            @paste="!barcode.canWrite && $event.preventDefault()"
            :autocomplete="barcode.canWrite ? 'on' : 'off'"
          ></b-input>
          <label class="fl-label" style="left: 13px; right: 12px" @click="$refs.barcode.focus()">Código de Barras</label>
          <b-form-feedback class="text-danger" v-text="errors.get('cd_barra')" v-if="errors.has('cd_barra')"></b-form-feedback>
          <span>Qtde. caracteres código de barra: {{ barcodeLength() }}</span>
        </b-col>
      </b-row>
      <b-row no-gutters class="pb-1 pr-0">
        <b-col md="12" cols="12" class="d-flex justify-content-end align-items-center flex-wrap">
          <div class="button-group">
            <b-btn
              @click="onScan()"
              class="secondary mr-1"
              :class="{ 'w-100': deviceSize == DeviceSizeEnum.XS }"
              :disabled="barcode.buttonDisabled"
            >Escanear código</b-btn>
            <b-btn
              @click="onCreateEvent()"
              class="secondary"
              :class="{ 'w-100': deviceSize == DeviceSizeEnum.XS }"
              :disabled="lossDisabled"
            >Apontar ocorrência</b-btn>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <h6 class=" ml-1">
          <span class="font-weight-bold">Qtde. NFs Completas</span>: {{ this.finishedInvoiceQuantity }}
        </h6>
      </b-row>
      <b-row>
        <h6 class="ml-1">
          <span class="font-weight-bold">Qtde. volumes bipados / Total de volumes</span>: {{ this.volumesBiped }}/{{ this.volumesTotal }}
        </h6>
      </b-row>
      <b-row>
        <h6 class="ml-1">
          <span class="font-weight-bold">Peso Bruto</span>: {{ this.finishedInvoiceWeight }}
        </h6>
      </b-row>

      <div class="loadingData" v-if="loadingData">
        <div class="loadingDataSpinner">
          <spinner v-if="loadingData" text-fg-color="#ffffff" message="Carregando..."></spinner>
        </div>
      </div>
    </div>

    <div class="card-footer d-flex flex-row-reverse">
      <div>
        <b-btn
          @click="onShowFinalizeVolumes()"
          variant="secondary"
          :disabled="finishIsDisabled"
          class="mr-1"
          :class="{ 'w-100': deviceSize == DeviceSizeEnum.XS }"
        >Finalizar por área</b-btn>
        <b-btn
          @click="openSpecialFinishedModal()"
          class="secondary btn"
          :class="{ 'w-100': deviceSize == DeviceSizeEnum.XS }"
          v-if="isSpecialFinished"
          :disabled="finishIsDisabled"
        >Finalizar especial</b-btn>
      </div>
    </div>

    <ApontamentoOcorrenciaModal ref="apontamentoOcorrenciaModal" @clearOccurrenceTable="onClear"></ApontamentoOcorrenciaModal>
    <ConferenciaFinalizarVolumesModal ref="finalizeVolumesModal" @clearVolumesTable="onClear"/>
  </div>
</template>
<script>
import AvisoErros from "../components/AvisoErros.vue";
import VolumeDetails from "../components/VolumeDetails.vue";
import ApontamentoOcorrenciaModal from "./ApontamentoOcorrenciaModal.vue";
import { formatDateTime, rowClassByDueDate } from "../utils";
import { DeviceSizeEnum, ParamTipoAreaEnum } from "../enums/GeneralEnums";
import Form from "../Form";
import Errors from "../Errors";
import ConsultaInventarioModal from "./ConsultaInventarioModal.vue";
import ConferenciaFinalizarVolumesModal from "./ConferenciaFinalizarVolumesModal.vue";

Vue.component("volume-details", VolumeDetails);

export default {
  components: {
    ConsultaInventarioModal,
    AvisoErros,
    ApontamentoOcorrenciaModal,
    ConferenciaFinalizarVolumesModal
  },
  data() {
    return {
      batch: {
        disabled: true,
        input: "",
        selected: [],
      },

      area: {
        input: "",
        id: 0,
      },

      pallet: {
        visible: true,
        disabled: true,
        input: "",
        required: false,
      },

      plate: {
        visible: false,
        disabled: true,
        input: "",
        required: false,
      },

      barcode: {
        input: "",
        value: "",
        disabled: true,
        lastTimeInput: 0,
        canWrite: false,
        buttonDisabled: true,
      },

      mdfe: {
        disabled: true,
        input: "",
      },

      groupId: null,
      isFullscreen: false,
      inputKey: 0,
      errors_array: [],
      notas_fiscais: [],
      volumesBiped: 0,
      volumesTotal: 0,
      volumeBipedQuantity: 0,
      finishedInvoiceQuantity: 0,
      finishedInvoiceWeight: 0,
      clearIsDisabled: true,
      finishIsDisabled: true,
      lossDisabled: false,
      invoiceDueAlert: false,
      invoiceDueDays: 0,
      isProcessing: false,
      song: new Audio(),
      success: require("../../public/audio/sucesso.mp3"),
      error: require("../../public/audio/erro.mp3"),
      desapont_beep: require("../../public/audio/bip_duplicado.mp3"),
      errors: new Errors(),
      loadingData: false,
      DeviceSizeEnum,
      fishedGroupForm: new Form({ finalizar_especial: false }),
      fields: [
        { name: "doc_fiscal.num_fiscal", title: "Nº Fiscal" },
        { name: "doc_fiscal.serie", title: "Serie" },
        {
          name: "doc_fiscal.dt_emissao", title: "Data Emissão",
          callback: value => this.formatDateTime(value)
        },
        {
          name: "doc_fiscal.dt_previsao", title: "Data Previsão",
          callback: value => this.formatDateTime(value)
        },
        { name: "doc_fiscal_volume.num_volume", title: "Volume" },
        { name: "doc_fiscal.qtd_volume", title: "Qtde. Volumes" },
        { name: "doc_fiscal.doc_fiscal_partes_env_emi.emi_cnpj", title: "CNPJ Emi" },
        { name: "doc_fiscal.doc_fiscal_partes_env_emi.emi_nome", title: "Razão Social Emi" },
        { name: "__slot:paramTipoArea", title: "Área CD" },
        { name: "doc_fiscal.num_lote", title: "Lote" },
        { name: "__slot:pallet", title: "Pallet" },
        { name: "doc_fiscal_volume.status.descr", title: "Status" },
        { name: "__slot:actions", title: "Ações", titleClass: "center aligned", dataClass: "center aligned" }
      ],
      css: {
        tableClass: "table",
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      triagem: null,
      optionsGrupoTriagem: [],
      applyManifestFilter: false,
    }
  },
  mounted() {
    this.loadGruposTriagem();
  },
  methods: {
    loadGruposTriagem() {
    new Form()
      .get("/api/conferencia_volume/grupo/triagem")
      .then(response => {
        this.optionsGrupoTriagem = [];
        response.forEach(m => {
          this.optionsGrupoTriagem.push({
            label: m.descr,
            value: m.pargrutri_id
          });
        });
      })
      .catch((errors) => {
        return new ReturnApi(errors, this);
      });
    },
    formatDateTime(value) {
      return formatDateTime(value);
    },
    onLoaded() {
      this.loadingData = false;
    },
    onClear() {
      this.clearIsDisabled = true;
      this.area.input = "";
      this.batch.input = "";
      this.batch.disabled = true;
      this.pallet.input = '';
      this.pallet.disabled = true;
      this.pallet.visible = true;
      this.plate.input = '';
      this.plate.disabled = true;
      this.plate.visible = false;
      this.barcode.input = '';
      this.barcode.disabled = true;
      this.finishedInvoiceQuantity = 0;
      this.finishedInvoiceWeight = 0;
      this.volumeTotal = 0;
      this.volumesBiped = 0;
      this.volumesTotal = 0;
      this.finishIsDisabled = true;
      this.mdfe.input = "";
      this.mdfe.disabled = true;
      this.barcode.buttonDisabled = true;
      this.triagem = null;
      this.errors = new Errors();
      this.applyManifestFilter = false;
    },
    onCreateEvent() {
      this.$refs.apontamentoOcorrenciaModal.onCreate();
    },
    onShowFinalizeVolumes() {
      const manifestKey = this.mdfe.input ? this.mdfe.input : null;
      const batches = this.batch.input ? this.batch.input : null;

      this.$refs.finalizeVolumesModal.onCreate(this.area.id, this.groupId, batches, manifestKey, this.triagem.value);
    },
    rowClass(data) {
      return rowClassByDueDate(
        data.doc_fiscal.dt_previsao,
        this.invoiceDueAlert,
        this.invoiceDueAlertDays);
    },
    onSetArea() {
      if (!this.area.input) {
        return;
      }
      new Form({})
          .get("/api/area?qrcode=" + this.area.input)
          .then(response => {
            this.loadingData = false;
            if (this.area.input) {
              new ReturnApi(response, this);
              this.isDisabled = false;

              if (!response.data.length) {
                this.area.input = "";
                this.barcode.input = "";
                this.$refs.barcode.focus();

                throw new Error("Área não encontrada!");
              }

              const area = response.data[0];
              const areaDetails = `A${area.areaId} - ${area.descr}`;
              this.$Simplert.open({
                title: "Confirma seleção de área?",
                message: areaDetails,
                customConfirmBtnText: "Sim",
                customCloseBtnText: "Não",
                type: "info",
                useConfirmBtn: true,
                onConfirm: () => {
                  this.loadingData = true;

                  // Area tipo Recebimento
                  if (area.paramTipoArea.cd === ParamTipoAreaEnum.RECEBIMENTO) {
                    this.pallet.visible = false;
                    this.plate.visible = true;
                    this.plate.disabled = false;
                    this.barcode.disabled = false;
                    this.mdfe.disabled = false;         
                    this.$nextTick(() => {
                      this.$refs.barcode.focus();
                    })
                  } else if (area.paramTipoArea.cd === ParamTipoAreaEnum.TRIAGEM) {
                    this.plate.visible = false;
                    this.pallet.visible = true;
                    this.pallet.disabled = false;
                    this.barcode.disabled = false;
                    this.mdfe.disabled = true;
                    this.mdfe.input = "";
                    this.$nextTick(() => {
                      this.$refs.pallet.focus();
                    });
                  } else {
                    this.pallet.disabled = false;
                    this.pallet.required = true;
                    this.plate.disabled = true;
                    this.mdfe.disabled = false;
                    this.$nextTick(() => {
                      this.$refs.pallet.focus();
                    })
                  }

                  this.batch.disabled = false;

                  // Setting the input on the same frame was not working
                  this.$nextTick(() => {
                    this.area.input = areaDetails;
                    this.area.id = area.areaId;
                    this.groupId = area.docfisvolbipgrp_id;
                    this.clearIsDisabled = false;
                    this.loadingData = false;
                  });

                },
                onClose: () => {
                  this.$Simplert.open({
                    title: "Seleção cancelada",
                    message: "",
                    customCloseBtnText: "Fechar",
                    type: "info",
                  });
                  this.area.input = "";
                },
              });
            }
          })
          .catch(error => {
            this.loadingData = false;

            if (error.message === "Área não encontrada!") {
              this.barcode.input = '';
              this.$refs.barcode.focus();
              this.barcode.buttonDisabled = false;

              this.$snotify.error("Área não encontrada!", 'Erro');
              return;
            }
            return;
          });
    },
    onFetchScreeningGroup() {
      this.loadingData = true;
      new Form({})
          .get(`/api/conferencia_volume/grupo/triagem/${this.triagem ? this.triagem.value : ''}/area/${this.area.input}`)
          .then((response) => {
            if(response.httpStatus === 200){
              this.loadingData = false;
              this.area.input = "";
              this.$Simplert.open({
                title: response.title,
                message: response.message,
                customCloseBtnText: "Fechar",
                type: "warning",
              });
              return;
            }else {
              this.onSetArea();
            }
          });
    },
    onSetBatch() {
      if (!this.batch.input) return;
      this.loadingData = true;
      new Form({})
        .get(`/api/conferencia_volume/grupo/pendente/${this.area.id}?lote=${this.batch.input}`)
        .then(response => {
          this.applyManifestFilter = false;
          this.confirmSetGroup(response);
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
    confirmSetGroup(response) {
      this.onSetGroupData(response);
    },
    playNotify(musica) {
      this.song.src = musica;
      this.song.play();
    },
    onScan() {
      if (this.isProcessing) {
        return;
      }
      this.isProcessing = true;
      this.barcode.buttonDisabled = true;
      if (this.barcode.input.length != 28 &&
        this.barcode.input.length != 29 &&
        this.barcode.input.length != 31) {

        this.barcode.input = '';
        this.$refs.barcode.focus();
        this.isProcessing = false;
        this.barcode.buttonDisabled = false;
        return this.$Simplert.open({
          title: "Atenção",
          message: "Código de barras inválido!",
          customCloseBtnText: "Fechar",
          type: "warning",
        });
      }
      const payload = new Form({
        area_id: this.area.id,
        docfisvolbipgrp_id: this.groupId ? this.groupId : null,
        pallet_id: this.pallet.input ? this.pallet.input.replace(/[^0-9]/g, '') : null,
        placa: this.plate.input ? this.plate.input : null,
        lote: this.batch.input ? this.batch.input : null,
        cd_barra: this.barcode.input,
        chave_mdfe: this.mdfe.input || null,
        pargrutri_id: this.triagem.value
      });
      this.barcode.value = this.barcode.input;
      payload
        .post("/api/conferencia_volume/bip")
        .then(response => {
          this.playNotify(this.success);
          this.onSetGroupData(response);

            const currentBeep = response.doc_fiscal_volume_bip[0];
            const invoiceNumber = currentBeep.doc_fiscal.num_fiscal;
            const volume = currentBeep.doc_fiscal_volume.num_volume;
            const message = `Volume ${volume} da nota ${invoiceNumber} bipado com sucesso!`;
            this.$snotify.success(message, 'Sucesso');
            this.barcode.input = '';
            this.$refs.barcode.focus();
            this.isProcessing = false;
            this.barcode.buttonDisabled = false;
          })
        .catch((errors) => {
          this.errors = payload.errors;
          const errorMassage = errors.message;
          const hasPermissionToDesapontVolume = this.getPermissionFw('conferencia_volume.desapontamento_de_volume');
          const isDuplicatedBip =
            typeof errorMassage === 'string' &&
            errorMassage.includes('já possui bip');

          if (isDuplicatedBip && hasPermissionToDesapontVolume) {
            this.$Simplert.open({
              title: "Deseja desapontar o volume?",
              message: "O volume não pode ser bipado mais de uma vez. Deseja desapontar?",
              customCloseBtnText: "Não",
              customConfirmBtnText: "Sim",
              useConfirmBtn: true,
              type: "warning",
              onConfirm: () => {
                const params = new URLSearchParams({
                  ...(this.groupId ? { docfisvolbipgrp_id: this.groupId } : {}),
                  ...(this.pallet.input ? { pallet_id: this.pallet.input } : {}),
                  ...(this.plate.input ? { placa: this.plate.input } : {}),
                  ...(this.batch.input ? { lote: this.batch.input } : {}),
                  pargrutri_id: this.triagem.value,
                  area_id: this.area.id,
                  cd_barra: this.barcode.value,
                }).toString();

                new Form({}).delete(`/api/conferencia_volume/bip?${params}`).then((data) => {
                  this.$snotify.success("Volume desapontado com sucesso.", 'Sucesso');
                  this.playNotify(this.success);

                  if(!data.dt_del || data.dt_del == null){
                    this.onSetGroupData(data);
                  } else {
                    this.onUnsetGroupData();
                  }               

                  this.barcode.input = '';
                  this.$refs.barcode.focus();
                  this.isProcessing = false;
                  this.barcode.buttonDisabled = false;
                  
                }).catch((err) => {
                  this.$Simplert.open({
                    title: "Atenção",
                    message: err.message,
                    customCloseBtnText: "Fechar",
                    type: "error",
                  })

                  this.barcode.input = '';
                  this.$refs.barcode.focus();
                  this.isProcessing = false;
                  this.barcode.buttonDisabled = false;
                });
              }
            });

            return;
          } else {
            this.playNotify(this.error);
          }

          if (errors.mensagem) {
            if (errors.mensagem.includes('Área inválida para o bip')) {
              let message = errors.mensagem + (errors.area_correta ? ` - Direcione para a area A${errors.area_correta.area_id} - ${errors.area_correta.descr}` : '');

              this.barcode.input = '';
              this.$refs.barcode.focus();
              this.isProcessing = false;
              this.barcode.buttonDisabled = false;

              return this.$Simplert.open({
                title: "Atenção",
                message: message,
                customCloseBtnText: "Fechar",
                type: "error",
              })
            }
          }

          if (errors.mensagem && errors.mensagem.includes('Unidade não parametrizada para triagem')) {
            this.$snotify.error(errors.mensagem, 'Erro');

            return;
          }

          if (errors.message && errors.message.includes("Nota não existe na sua unidade.")) {

            this.barcode.input = '';
            this.$refs.barcode.focus();
            this.isProcessing = false;
            this.barcode.buttonDisabled = false;

            return this.$Simplert.open({
              title: "Atenção",
              message: errors.message,
              customCloseBtnText: "Fechar",
              type: "error",
            });
          }

          if (errors.message && errors.message.includes("Volume não existe na nota")) {
            this.barcode.input = '';
            this.$refs.barcode.focus();
            this.isProcessing = false;
            this.barcode.buttonDisabled = false;

            return this.$Simplert.open({
              title: "Atenção",
              message: errors.message,
              customCloseBtnText: "Fechar",
              type: "error",
            });
          }

          if (errors.pallet_id) {
            this.barcode.input = '';
            this.$refs.barcode.focus();
            this.isProcessing = false;
            this.barcode.buttonDisabled = false;

            return this.$Simplert.open({
              title: "Atenção",
              message: errors.pallet_id[0],
              customCloseBtnText: "Fechar",
              type: "error",
            })
          }

          this.barcode.input = '';
          this.$refs.barcode.focus();
          this.isProcessing = false;
          this.barcode.buttonDisabled = false;
          this.playNotify(this.desapont_beep);
          return new ReturnApi(errors, this);
        });

    },
    onSetGroupData(group) {
      this.groupId = group.docfisvolbipgrp_id;
      this.volumesTotal = group.total_volumes;
      this.volumesBiped = group.volumes_bipados;
      this.finishedInvoiceWeight = `${group.peso_bruto_finalizadas.toFixed(2)} kg`;
      this.finishedInvoiceQuantity = group.notas_finalizadas;
      this.finishIsDisabled = false;
    },
    onUnsetGroupData() {
      this.groupId = null;
      this.volumesTotal = 0;
      this.volumesBiped = 0;
      this.finishedInvoiceWeight = 0;
      this.finishedInvoiceQuantity = 0;
      this.finishIsDisabled = true;
    },
    onSpecialFinish() {
      this.loadingData = true;
      new Form({})
        .post(`/api/conferencia_volume/grupo/${this.groupId}/finalizar_especial`)
        .then(() => {
          this.loadingData = false;
          this.$Simplert.open({
            title: "Sucesso",
            message: "Conferência finalizada com pendências!",
            customCloseBtnText: "Fechar",
            type: "warning"
          });
          this.onClear();
        })
        .catch(errors => {
          this.loadingData = false;
          if (errors.mensagem.includes("Não existe area de triagem para a nota informada")) {
            return this.$Simplert.open({
              title: "Atenção",
              message: errors.mensagem,
              customCloseBtnText: "Fechar",
              type: "error",
            });
          }
          return new ReturnApi(errors, this);
        });
    },
    barcodeLength() {
      return this.barcode.input.length;
    },
    setPermissions() {
      this.barcode.canWrite = this.getPermissionFw("geral.digitarbip");
      this.invoiceDueAlert = this.$store.getters.unidade_active.aviso_vencimento;
      this.invoiceDueAlertDays = this.$store.getters.unidade_active.dias_vencimento;
    },
    openSpecialFinishedModal() {
      this.$Simplert.open({
        title: "Atenção",
        message: "Deseja finalizar o grupo sem apontar ocorrência para volumes pendentes?",
        customConfirmBtnText: "Sim",
        customCloseBtnText: "Fechar",
        type: "warning",
        useConfirmBtn: true,
        onConfirm: () => this.onSpecialFinish()
      });
    }
  },
  watch: {
    applyManifestFilter() {
      this.batch.input = "";
      this.mdfe.input = "";
    },
    'barcode.input'(newData, oldData) {
      if (newData === "") return;
      const inputTime = Date.now();
      if (oldData.length > 1 && !this.barcode.canWrite && inputTime - this.barcode.lastTimeInput > 100) {
        this.$nextTick(() => {
          this.barcode.input = "";
          alert("Apenas bipagem é permitida.");
        });
      }
      this.barcode.lastTimeInput = inputTime;
      if (newData.length == 28 || newData.length == 29 || newData.length == 31) {
        this.barcode.buttonDisabled = false;
      } else {
        this.barcode.buttonDisabled = true;
      }
    },
    'pallet.input'(data) {
      if (this.pallet.required) {
        this.barcode.disabled = data.length === 0;
      }
    },
    isUserDataLoaded(newVal) {
      if (newVal) this.setPermissions();
    },
    'triagem'(newData){
      if(newData) {
        this.clearIsDisabled = false;
      }
    }
  },
  computed: {
    deviceSize() {
      return this.$store.getters.device_size;
    },
    isUserDataLoaded() {
      return this.$store.getters.is_user_data_loaded;
    },
    isSpecialFinished() {
      return this.getPermissionFw("conferencia_volume.botao.finalizar_especial");
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (vm.isUserDataLoaded) vm.setPermissions();
    });
  }
};
</script>
